const API_BASE_URL = '/website-api';

const httpPost = async (uri, headers, jsonBody) => {
  try {
    let response = await fetch(uri, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(jsonBody),
    })

    if (!response.ok) {
      throw response
    }

    if (response.status === 204) {
      return
    }

    let responseJson = await response.json()

    return responseJson
  } catch (error) {
    throw error
  }
}

export function sendContactInfo({ name, telOrEmail }) {
  return httpPost(
    `${API_BASE_URL}/contact_info`,
    {},
    { name, tel_or_email: telOrEmail }
  )
}
